import api from './api';

export function postAgileSimulatorResult(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion/agil`, data)
  }

export function getAgileSimulatorTasas() {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/get-tasas-pricing`)
  }

  export function getAgileSimulatorCreditBound(grupo,tasa) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/get-credit-bound/${grupo}/${tasa}`)
  }

export function getAgileLineasDeCredito() {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/lineas-credito`);
  }